<template>
  <svg
    v-if="customSvg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    :fill="color || 'currentColor'"
  >
    <path :d="customSvg" />
  </svg>
  <component
    v-else-if="iconComponent"
    :is="iconComponent"
    :size="size"
    :weight="weight"
    :color="color"
  />
  <span v-else class="inline-block w-6 h-6 text-xs text-[#9ca3af]">{{ name }}</span>
</template>

<script setup lang="ts">
import { computed, h } from 'vue'
import * as PhosphorIcons from '@phosphor-icons/vue'

type IconWeight = 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone'

interface Props {
  name: string
  size?: number | string
  weight?: IconWeight
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  weight: 'regular',
})

const CUSTOM_ICONS: Record<string, string> = {
  facebook:
    'M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.52-.14-2.71-.14-2.77 0-4.79 1.69-4.79 4.92v2.58H7v4h3V22h4v-8.5z',
  'facebook-f':
    'M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.52-.14-2.71-.14-2.77 0-4.79 1.69-4.79 4.92v2.58H7v4h3V22h4v-8.5z',
}

const customSvg = computed(() => CUSTOM_ICONS[props.name.toLowerCase()] || null)

const iconComponent = computed(() => {
  if (customSvg.value) return null

  const iconName = `Ph${props.name
    .split(/[-_\s]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('')}`

  const Icon = (PhosphorIcons as Record<string, any>)[iconName]

  if (!Icon) {
    console.warn(
      `Icon "${props.name}" (resolved as "${iconName}") not found. Available icons: ${Object.keys(PhosphorIcons).slice(0, 10).join(', ')}...`
    )
    return null
  }

  return () =>
    h(Icon, {
      size: props.size,
      weight: props.weight,
      color: props.color,
    })
})
</script>
